// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React, { useState, useEffect } from 'react';
import { COLOR, useWindowDimensions, THAI_STARTUS, COLOR_STARTUS, loadMarkers, loadMarkerswiothTracking } from '../const'
// import axios from 'axios';
// import TodoInput from '../components/TodoInput';
import Map from '../components/Map';
import styled from '@emotion/styled'
import dateFormat from 'dateformat';
import banner from '../images/banner.png'
// import Header from '../components/Header';
// import OrderList from '../components/OrderList';
// import BarSearch from '../components/BarSearch';

import { getStatusOrder, getLocationOrder, getTracking } from '../api/githubAPI';

const Tracking = () => {

  const { height } = useWindowDimensions()
  const [trackingNo, setTrackingNo] = useState('')
  const [order, setOrder] = useState()
  const [IsStatus, setIsStatus] = useState(0);
  const [status, setStatus] = useState({ status: "" });
  const [location, setLocation] = useState([]);
  const [issuesError, setIssuesError] = useState<Error | null>(null)

  useEffect(() => {
    // if (trackingNo.length === 17) {
    //   callGetStatusOrder()

    // }
    if (issuesError) {
      setIsStatus(0)
    }
    console.log(status, order, (issuesError)?true:false)
 
   

  }, [IsStatus, status, issuesError])

  useEffect(() => {
    
    if (status.status !== "") {
      fetchTracking();
    }
  }, [status])


  useEffect(() => {
    
    if (status.status !== "" && order !== undefined) {
      callGetLocationOrder();
    }
  }, [order])


  // console.log('call Location Order',IsStatus);
  async function fetchTracking() {
    const Tracking: any = await getTracking(trackingNo)
    console.log('Tracking', Tracking)
    if(Tracking.length!==0){
      setOrder(Tracking)
      setLocation(loadMarkers([Tracking]));
      setIsStatus(1)
    }
    

  }

  async function fetchStatusOrder() {
    const StatusOrder: any = await getStatusOrder(trackingNo)
    console.log('StatusOrder', StatusOrder)
    setStatus(StatusOrder);

  }

  const callGetStatusOrder = async () => {

    try {
      setIssuesError(null)
      await Promise.all([fetchStatusOrder(), fetchTracking()])
    } catch (err) {
      console.error(err)
      setIssuesError(err)
      // setIsStatus(0)
    } finally {
      console.log('finally', status);
    }
  }


  const callGetLocationOrder = async () => {
    // console.log('call Location Order');

    async function fetchStatusOrder() {
      const LocationOrder: any = await getLocationOrder(trackingNo)
      // console.log('LocationOrder', LocationOrder)
      const tmp = loadMarkers([order])
      const location_tmp = tmp.concat(loadMarkerswiothTracking(LocationOrder))
      // console.log('location_tmp',location_tmp)
      setLocation(location_tmp)
    }
    try {
      await Promise.all([fetchStatusOrder()])
    } catch (err) {
      console.error(err)
    } finally {
      // setIsStatus(IsStatus+1)
    }
  }



  const Menu = ({ uri, text }: { uri: string, text: string }) => {
    const current_uri = window.location.pathname
    return (
      <li>
        <a className={current_uri === uri ? styles.active : ""} href={uri}>{text}</a>
      </li>
    )
  }

  const Header = () => {
    return (
      <div className={styles.root}>
        <ul className={styles.menu}>
          <Menu uri={"/"} text={"TRACKING ORDER"}></Menu>
        </ul>
      </div>
    )
  }

  const LineStatus = ({ status }: { status: string }) => {
    const contmp = classStatus(status)
    return (
      <ul className={styles.circleBar}>
        <li className={contmp >= 1 ? 'black' : ''}>
          <span>ค้นหาคนขับ
        {contmp > 1 ? <i className="icon-ok" /> : null}
          </span></li>
        <li className={contmp >= 2 ? 'black' : ''}>
          <span>กำลังไปรับสินค้า
      {contmp > 2 ? <i className="icon-ok" /> : null}
          </span></li>
        <li className={contmp >= 3 ? 'black' : ''}>
          <span>กำลังไปส่งสินค้า
      {contmp > 3 ? <i className="icon-ok" /> : null}
          </span></li>
        <li className={contmp >= 4 ? 'black' : ''}>
          <span>จัดส่งสำเร็จ
      {contmp >= 4 ? <i className="icon-ok" /> : null}
          </span></li>
      </ul>
    )
  }
  const classStatus = (status: string) => {
    switch (status) {
      case 'ASSIGNING_DRIVER':
        return 1;
        break;
      case 'ON_GOING':
        return 2;
        break;
      case 'PICKED_UP':
        return 3;
        break;
      case 'COMPLETED':
        return 4;
        break;
      case 'CANCELED':
        return 0;
        break;
      case 'WAITING':
        return 0;
        break;
      case 'now':
        return 0;
        break;

      default:
        return 0;
        break;
    }
  }

  const styles = {
    page: css`
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 25px 50px 0 rgba(0, 0, 0, 0.1);
      margin: 0 auto;
      padding-top: 61px;
      width: 90%;
    `,
    root: css`
      position: absolute;
      left: 50%;
      top:0;
      transform: translate(-50%, 0);
      z-index: 9999;
    `,
    wrapBanner: css`
    display: flex;
    flex-direction: column;
    padding: 15px;
    background-color:  #FFFFFF;
      img{
        width: 100%
      }
    `,
    error: css`
      display: flex;
      flex-direction: column;
      padding: 15px;
      margin-top: 15px;
      background-color:  #F7F7F7;
      height: ${height}px;
      ont-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 150px;
      color: ${COLOR['DARK_1']};
      text-align: center;
    `,
    wrapStatus: css`
      display: flex;
      flex-direction: column;
      padding: 15px;
      margin-top: 15px;
      background-color:  #F7F7F7;
        .header{
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        margin-bottom:15px;
        margin-top:15px;
        text-align: center;
        }
      .row-status{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .item{
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 15px;
          .box-title{
            display: flex;
            flex-direction: column;
            padding-left: 15px;
          }
          .title{
            margin-bottom: 0;
            font-size: 18px;
            color:  ${COLOR['BLUE_DARK']};
          }
          .circle{
            min-width: 41px;
            min-height: 41px;
            border-radius: 50%;
            &.blue-dark{
              background-color:  ${COLOR['BLUE_DARK']} !important;
            }
            &.blue{
              background-color:  #7886FF !important;
            }
            &.yellow{
              background-color:  ${COLOR['YELLOW_1']} !important;
            }
            &.green{
              background-color:  #1ABC9C !important;
            }
            &.pink{
              background-color:  #E54363 !important;
            }
          }
        }
      }
  `,
    barsearch: css`
      width: 100%;
      height: 51px;
      background: #FFF;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #444966;
      font-size: 20px;
      .itembar{
        font-size: 20px;
      }
      input {
        width: 385px;
        height: 40px;
        font-size: 20px;
        // opacity: 0.3;
        border: 2px solid ${COLOR['BLUE_DARK_OPA_1']};
        color:${COLOR['BLUE_DARK']};
        border-radius: 7px;
        &:focus{
          // border: 2px solid #444966;
          outline: none;
        }
      }
    `,
    barstatus: css`
      margin-top: 20px;
      width: 100%;
      height: 51px;
      background: #F7F7F7;
      display: flex;
      font-size: 14px;
      align-items: center;
      color: #444966;
    `,
    itembar: css`
      width: 180px;
      text-align: center;
      &:nth-child(odd){
        text-align: right;
        font-weight: 700;
        padding-right: 0px;
        margin-right: 15px;
    }
    .text-status{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 28px;
      padding-left: 15px;
    }
    `,
    menu: css`
      list-style-type: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      background-color: #ffffff;
      width: 372px;
      position: relative;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.13);
      border-radius: 0px 0px 13px 13px;
      li {
        float: left;
        width: 372px;
        &:nth-child(2){
          border-radius: 0px 0px 13px 0px;
        }
        &:nth-child(1){
          border-radius: 0px 0px 0px 13px;
        }
      }
      
      li a {
        display: block;
        color: white;
        text-align: center;
        padding: 5px 16px;
        font-size: 22px;
        text-decoration: none;
        color: ${COLOR['BLUE_DARK']};
        border-bottom: 2px solid transparent;
      }
      
      li a:hover {
        background-color: ${COLOR['BLUE_DARK_OPA_1']};
      }
    `,
    active: css`
      color: ${COLOR['YELLOW_1']} !important;
      font-weight: bold;
      border-bottom: 2px solid ${COLOR['YELLOW_1']}!important;
    `,
    button: css`
      position: absolute;
      bottom: 0px;
    `,
    dot: css`
    height: 25px;
    width: 25px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    `,
    footer: css`
    width: 100%;
    height: 51px;
    line-height: 50px;
    background: #FFF;
    font-size: 18px;
    text-align: center;
    `,
    circleBar: css`
    margin:0;
    padding:15px;
    height: 100%;
    display: flex;
    
    `,

  };

  type StatusComponentProps = {
    status: string
  }


  const StyledSpan = styled('span') <StatusComponentProps>`
    height: 28px;
    width: 28px;
    float: left;
    background-color: ${props => props.status === "" ? COLOR['BLUE_DARK'] : COLOR_STARTUS[props.status]};
    border-radius: 50%;
    display: inline-block;
  `;

  type lineComponentProps = {
    status: string
  }

  const StyledlineStatus = styled('div') <lineComponentProps>`
      position: absolute;
      bottom: 35px;
      right: 0px;
      li{
        float: left;
        position: relative;
        text-align: center;
        list-style: none;
        background-color: ${props => props.status === "" ? COLOR['BLUE_DARK'] : COLOR['YELLOW_1']};
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right:45px;
        width: max-content;
        border-radius: 13px;
        z-index: 0;
       
        span{
          color:#ffffff;
          border-radius: 13px;
          font-size: 14px;
          padding: 8px 10px;
          background-color: ${COLOR['BLUE_DARK']};
        }
        
        i{
          padding-left:5px;
        }
        &:first-child{
          &:after{
            content: none;
          }
        }
        &:after{
          content: '';
          position: absolute;
          width:100%;
          height: 3px;
          background: ${COLOR['BLUE_DARK']};
          top: 17px;
          left: -45px;
          z-index: -1;
        }
      }
      .black{
        // background-color: ${COLOR['BLUE_DARK']} !important;
        // color:#ffffff !important;
        span{
          color: ${COLOR['DARK_2']};
          background-color: ${COLOR['YELLOW_1']};
        }
        }
    `;

  type StyledComponentProps = {
    height: number
  }

  const StyledMap = styled('div') <StyledComponentProps>`
      position: relative ;
      line-height: 20px;
      color: #ffffff;
      font-size: 14px;
      width: 100%;
      height:${props => props.height}px !important;
      border-radius: 7px;
      text-align: center;
    `;

  return (
    <>
      <Header />
      <div className={styles.page}>
        <div className={styles.barsearch}>
          <div className={styles.itembar}>ติดตามสถานะสินค้า</div>
          <input
            type="text"
            maxLength={17}
            className={styles.itembar}
            placeholder={'search for tracking number'}
            onChange={e => setTrackingNo(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                callGetStatusOrder()
              }
            }}
            value={trackingNo}
          />
        </div>
        {(IsStatus) ? (
          <>
            <div className={styles.barstatus}>
              <div className={styles.itembar}>DELIVERY DATE</div>
              <div className={styles.itembar}>{order.deliveryAt === undefined ? '-' : dateFormat(order.deliveryAt.dateDelivery, "ddd dd-mm-yyyy") + ' ' + dateFormat(order.deliveryAt.dateDelivery, "H:MM")}</div>
              <div className={styles.itembar}>Status</div>
              <div className={styles.itembar}>
                <StyledSpan status={`${status.status}`} />
                <div className="text-status">{THAI_STARTUS[`${status.status}`]}</div>
              </div>
              <div className={styles.itembar}>SENDER</div>
              <div className={styles.itembar}>{order.shop === undefined ? order.shopInformation.name : order.shop.name}</div>
              <div className={styles.itembar}>CONSIEGNEE</div>
              <div className={styles.itembar}>{order.contact.name}</div>
            </div>
            <StyledMap height={height} >
              <Map route={location} zoom={13} />
              <StyledlineStatus status={`${status.status}`} >
                <LineStatus status={`${status.status}`} />
              </StyledlineStatus>
            </StyledMap>
          </>
        ) : (issuesError) ? (
          <div>
            <div className={styles.wrapStatus}>
              <div className={styles.error}>TRACK NOT FOUND</div>
            </div>
          </div>
        ) : (
              <div>
                <div className={styles.wrapStatus}>
                  <div className="header">สถานะสินค้า</div>
                  <div className="row-status">
                    <div className="item">
                      <div className="circle blue-dark" />
                      <div className="box-title">
                        <label className="title">ASSIGNING</label>
                        <label className="title">ค้นหาคนขับ</label>
                      </div>
                    </div>
                    <div className="item">
                      <div className="circle blue" />
                      <div className="box-title">
                        <label className="title">MATCHED</label>
                        <label className="title">กำลังไปรับสินค้า</label>
                      </div>
                    </div>
                    <div className="item">
                      <div className="circle  yellow" />
                      <div className="box-title">
                        <label className="title"> PICKED UP</label>
                        <label className="title">กำลังไปส่ง</label>
                      </div>
                    </div>
                    <div className="item">
                      <div className="circle  green" />
                      <div className="box-title">
                        <label className="title">COMPLETED</label>
                        <label className="title">จัดส่งสินค้าสำเร็จ</label>
                      </div>
                    </div>
                    <div className="item">
                      <div className="circle  pink" />
                      <div className="box-title">
                        <label className="title">CANCELLED</label>
                        <label className="title">ยกเลิกการส่งสินค้า</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.wrapBanner}>
                  <img src={banner} />
                </div>
              </div>
            )}


        {/* <BarSearch textSearch={'Tracking ON.'} /> */}
        {/* <OrderList /> */}

        <div className={styles.footer}>
          Copyright 2020
        </div>
      </div>
    </>
  );



}





export default Tracking;